import { createStore } from "vuex";
import bootstrap from "bootstrap/dist/js/bootstrap.min.js";
import { auth } from "./auth.module";
import { reset } from "./reset.module";
import { profile } from "./profile.module";

export default createStore({
  state: {
    hideConfigButton: true,
    isPinned: true,
    showConfig: false,
    isTransparent: "",
    isRTL: false,
    color: "",
    isNavFixed: false,
    isAbsolute: false,
    showNavs: true,
    showSidenav: true,
    showNavbar: true,
    showFooter: true,
    showMain: true,
    navbarFixed:
      "position-sticky blur shadow-blur left-auto top-1 z-index-sticky px-0 mx-4",
    absolute: "position-absolute px-4 mx-0 w-100 z-index-2",
    bootstrap,
    // Estado para el navbar minimizado
    isNavbarMinimized: false,
    // Usuario y permisos
    user: {
      permissions: {}
    }
  },
  modules: {
    auth,
    reset,
    profile,
  },
  mutations: {
    toggleConfigurator(state) {
      state.showConfig = !state.showConfig;
    },
    navbarMinimize(state) {
      const sidenav_show = document.querySelector(".g-sidenav-show");
      if (sidenav_show) {
        if (sidenav_show.classList.contains("g-sidenav-hidden")) {
          sidenav_show.classList.remove("g-sidenav-hidden");
          sidenav_show.classList.add("g-sidenav-pinned");
          state.isPinned = true;
          state.isNavbarMinimized = false;
        } else {
          sidenav_show.classList.add("g-sidenav-hidden");
          sidenav_show.classList.remove("g-sidenav-pinned");
          state.isPinned = false;
          state.isNavbarMinimized = true;
        }
      }
    },
    sidebarType(state, payload) {
      state.isTransparent = payload;
    },
    cardBackground(state, payload) {
      state.color = payload;
    },
    navbarFixed(state) {
      if (state.isNavFixed === false) {
        state.isNavFixed = true;
      } else {
        state.isNavFixed = false;
      }
    },
    toggleEveryDisplay(state) {
      state.showNavbar = !state.showNavbar;
      state.showSidenav = !state.showSidenav;
      state.showFooter = !state.showFooter;
    },
    toggleHideConfig(state) {
      state.hideConfigButton = !state.hideConfigButton;
    },
    // Mutaciones para gestionar usuario y permisos
    setUserPermissions(state, permissions) {
      if (!state.user) {
        state.user = {};
      }
      state.user.permissions = permissions;
    },
    setUser(state, user) {
      state.user = user;
    },
    // Mutación para limpiar datos del usuario
    clearUser(state) {
      state.user = {
        permissions: {}
      };
    }
  },
  actions: {
    toggleSidebarColor({ commit }, payload) {
      commit("sidebarType", payload);
    },
    setCardBackground({ commit }, payload) {
      commit("cardBackground", payload);
    },
    // Acción para obtener permisos del usuario
    async fetchUserPermissions({ commit }) {
      const apiUrl = process.env.VUE_APP_API_BASE_URL || 'http://teleconnect.test/api/v2';
      
      // Obtener el token de auth_token en localStorage
      const tokenJWT = localStorage.getItem('auth_token');
      
      // Verificar token
      if (!tokenJWT) {
        console.warn("No se encontró token JWT en localStorage - fetchUserPermissions");
        commit('clearUser');
        return {};
      }
      
      try {
        // Configurar headers para la petición
        const headers = {
          'Authorization': `Bearer ${tokenJWT}`,
          'Accept': 'application/json'
        };
        
        // Hacer petición a la API
        const response = await fetch(`${apiUrl}/me/permissions`, { headers });
        const data = await response.json();
        
        if (response.ok && data.success && data.data) {
          commit('setUserPermissions', data.data);
          return data.data;
        } else {
          console.warn("No se pudieron obtener los permisos:", data.message || 'Error de respuesta');
          if (response.status === 401) {
            // Token inválido, limpiar todo
            commit('clearUser');
            localStorage.removeItem('auth_token');
            localStorage.removeItem('userF');
          }
          return {};
        }
      } catch (error) {
        console.error("Error al obtener permisos:", error);
        return {};
      }
    }
  },
  getters: {
    // Getter para el estado de minimización del navbar
    isNavbarMinimized: (state) => state.isNavbarMinimized,
    
    // Getters para verificar permisos
    hasModuleAccess: (state) => (moduleId) => {
      // Si no hay permisos o usuario
      if (!state.user || !state.user.permissions) {
        return false;
      }
      
      // Si el usuario tiene permisos de admin, tiene acceso a todo
      if (state.user.permissions.admin === true) {
        return true;
      }
      
      // Verificar el permiso específico
      return state.user.permissions[moduleId] === true;
    },
    
    // Getter para obtener todos los permisos del usuario
    userPermissions: (state) => {
      return state.user?.permissions || {};
    },
    
    // Getter para obtener el usuario completo
    currentUser: (state) => {
      return state.user || {};
    }
  },
});